module.exports = __webpack_public_path__ + "img/defaultImg.aaf16e72.png";